/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Modal, withStyles, CircularProgress } from '@material-ui/core'
import styles from './styles'
import { PreviewHeader } from './components'
import { useSelector } from 'react-redux'
import URL from 'src/api/url'
import { getCoursePreviewTokenService } from 'src/api/course'
import { useCoursePublish } from 'src/contexts/course-publish-context'
const CoursePreview = props => {
  const { handleCloseModal, classes, isModalOpen } = props
  const course = useSelector(state => state.course.course)
  const me = useSelector(state => state.authentication.me)
  const [width, setWidth] = React.useState('100%')
  const [height, setHeight] = React.useState('100%')
  const [type, setType] = React.useState('desktop')
  const iframeRef = React.useRef(null)
  const [iframeLoading, setIframeLoading] = React.useState(true)
  const publishState = useCoursePublish()
  const [previewToken, setPreviewToken] = React.useState(null)

  React.useEffect(() => {
    if (isModalOpen) setIframeLoading(true)
  }, [isModalOpen])

  // The learner app runs on its own origin with no admin session, so an unpublished course is only
  // reachable with a short-lived token in the URL. Published courses need nothing extra.
  React.useEffect(() => {
    if (
      !isModalOpen ||
      !course?.id ||
      !publishState?.isLoaded ||
      publishState.isPublished
    ) {
      setPreviewToken(null)
      return
    }

    let cancelled = false

    getCoursePreviewTokenService(course.id)
      .then(response => {
        // Same { data, statusCode } envelope the rest of the API uses.
        const token = (response?.data ?? response)?.token
        if (!cancelled) setPreviewToken(token ?? null)
      })
      .catch(() => {
        if (!cancelled) setPreviewToken(null)
      })

    return () => {
      cancelled = true
    }
  }, [isModalOpen, course?.id, publishState?.isLoaded, publishState?.isPublished])

  const getPreviewUrl = () => {
    const collectionId = course?.courseCollectionId
    if (collectionId && me) {
      // widget-redirect only accepts the key of the shop that owns the collection. A collaborator
      // from another shop has a different key of their own, so prefer the owner's.
      const publicKey = course.collectionPublicKey ?? me.publicKey ?? ''
      const email = encodeURIComponent(me.email || '')
      const name = encodeURIComponent(me.name || '')
      const type = 'sidebar'
      const base = `${URL.APP_URL}widget-redirect/${collectionId}/${publicKey}/${email}/${name}/${type}?courseId=${course.id}&nav=first_card`

      return previewToken ? `${base}&previewToken=${previewToken}` : base
    }

    const base = URL.APP_URL + course?.code

    return previewToken ? `${base}?previewToken=${previewToken}` : base
  }
  return (
    <Modal
      open={isModalOpen}
      onClose={() => {
        // Stop audio and speechSynthesis in the iframe before closing
        if (iframeRef.current) {
          iframeRef.current.contentWindow?.postMessage(
            { type: 'STOP_AUDIO' },
            '*',
          )
        }
        handleCloseModal()
      }}
      iv
      style={{
        zIndex: '9999999',
      }}
      className={classes.modal}
      BackdropProps={{
        style: {
          display: 'none',
          zIndex: '9999999 !important',
        },
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <PreviewHeader
          handleCloseModal={() => {
            // Stop audio and speechSynthesis in the iframe before closing
            if (iframeRef.current) {
              iframeRef.current.contentWindow?.postMessage(
                { type: 'STOP_AUDIO' },
                '*',
              )
            }
            handleCloseModal()
          }}
          setHeight={setHeight}
          setWidth={setWidth}
          setType={setType}
          type={type}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
          }}
        >
          <div
            style={{
              padding: type != 'desktop' ? '24px' : '0',
              borderRadius: type != 'desktop' ? '48px' : '0',
              backgroundColor: type != 'desktop' ? '#f5f5f5' : 'transparent',
              width: width,
              height: height,
              position: 'relative',
            }}
          >
            {iframeLoading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1,
                }}
              >
                <CircularProgress />
              </div>
            )}
            <iframe
              ref={iframeRef}
              width={'100%'}
              height={'100%'}
              style={{
                border: '0',
                borderRadius: type != 'desktop' ? '24px' : '0',
              }}
              title={course?.name}
              src={getPreviewUrl()}
              allowFullScreen
              onLoad={() => setIframeLoading(false)}
            ></iframe>
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default withStyles(styles)(CoursePreview)
